import { Typography } from '@mui/material';
import Decimal from 'decimal.js';
import { compact } from 'lodash';

import { TableCell } from '@/components/lists/TableCell';
import { COLORS } from '@/styles/tokens/colors';
import { sumDecimalJS } from '@/utils/decimalJSUtils';
import { formatCurrency } from '@/utils/formatting/currency';

interface DispositiveProvisionsTaxDueProps {
  estateTax: Decimal;
  gstTax: Decimal;
}
export function DispositiveProvisionsTaxDue({
  estateTax,
  gstTax,
}: DispositiveProvisionsTaxDueProps) {
  if (estateTax.lessThanOrEqualTo(0) && gstTax.lessThanOrEqualTo(0))
    return null;

  const taxDue = sumDecimalJS(compact([estateTax, gstTax])).abs();

  let heading = 'Estate tax';
  if (gstTax?.greaterThan(0) && !estateTax?.greaterThan(0)) {
    heading = 'GST tax';
  } else if (gstTax?.greaterThan(0) && estateTax?.greaterThan(0)) {
    heading = 'Estate & GST tax';
  }

  return (
    <TableCell
      heading={heading}
      RightContent={
        <Typography variant="body-xs" color={COLORS.MATH.NEGATIVE}>
          ({formatCurrency(taxDue)})
        </Typography>
      }
    />
  );
}
